module.exports = __webpack_public_path__ + "img/macys-logo.cf43c86d.png";